module.exports = __webpack_public_path__ + "static/media/Gratitude.a60d6989.mp3";